const authToken = () => {
  try {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user && user.access_token) {
        return user.access_token;
      }
    }
  } catch (error) {
    console.error('Error retrieving auth token:', error);
  }

  return '';
};

export default authToken;
